<template>
    <div class="ebbly-info">
        <div class="row-line">
            <div
                class="row-line-item bg-lazy"
                style="cursor: pointer"
                @click="jump"
                v-lazy:background-image="inviteImg"
            ></div>

            <div class="row-line-item download-bg">
                <div
                    v-lazy:background-image="require('../../../assets/ebbly-app.png')"
                    class="ebbly-app-img"
                ></div>

                <div class="download-content">
                    <h3 class="title">{{$t('download_ebbly')}}</h3>
                    <p class="text">{{$t('ebbly_intro')}}</p>

                    <div>
                        <a
                            href="https://apps.apple.com/cn/app/iapp-best-travel-companion/id1332627856"
                            target="_blank"
                            class="store-img-link"
                        >
                            <img
                                class="store-img"
                                v-lazy="require('../../../assets/app_badge_apple.png')"
                            />
                        </a>

                        <a
                            href="https://play.google.com/store/apps/details?id=com.ifreegroup.ebbly"
                            target="_blank"
                            class="store-img-link"
                        >
                            <img
                                class="store-img"
                                v-lazy="require('../../../assets/app_badge_google.png')"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部介绍 -->
        <ul class="about-list">
            <li class="list-item">
                <div class="list-item-title">
                    <span class="icon-chat"></span>
                    {{$t('quick_answer')}}
                </div>
                <p class="list-item-text">{{$t('quick_answer_content')}}</p>
            </li>
            <li class="list-item">
                <div class="list-item-title">
                    <span class="icon-secure"></span>
                    {{$t('secure')}}
                </div>
                <p class="list-item-text">{{$t('secure_content')}}</p>
            </li>
            <li class="list-item">
                <div class="list-item-title">
                    <span class="icon-deals"></span>
                    {{$t('curated_deals')}}
                </div>
                <p class="list-item-text">{{$t('curated_deals_content')}}</p>
            </li>
            <li class="list-item">
                <div class="list-item-title">
                    <span class="icon-free-data"></span>
                    {{$t('free_data')}}
                </div>
                <p class="list-item-text">{{$t('free_data_content')}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
import { linkTo } from "@/lib/utils";

export default {
    computed: {
        //邀请活动的图片
        inviteImg() {
            let lang = this.$local.get("lang") || "en-US";
            if (lang === "en-US") {
                return "http://g1.ifreegroup.co/ebbly/20190730/2ca8ed04ac62b2b8fe8e06ee43c1215a.png";
            } else {
                return "http://g1.ifreegroup.co/ebbly/20190820/7b0d159721c0ed6753fb2ae5c2ffc995.png";
            }
        }
    },
    methods: {
        jump() {
            if (this.$store.getters.token) {
                linkTo("/invite");
            } else {
                this.$store.dispatch("toggleShowLogin", true);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.ebbly-info {
    margin-top: 80px;

    .bg-lazy {
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
    }

    .about-list {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 60px;

        .list-item {
            flex: 1;
            box-sizing: border-box;
            padding: 0 27px;

            &:first-child {
                padding-left: 0;
            }
            &:last-child {
                padding-right: 0;
            }

            .list-item-title {
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 14px;

                .icon-chat,
                .icon-free-data,
                .icon-secure,
                .icon-deals {
                    display: inline-block;
                    vertical-align: middle;
                    width: 25px;
                    height: 25px;
                    margin-right: 10px;
                }

                .icon-chat {
                    background: url("../../../assets/logo/home-sprite.png") -54px -10px;
                }
                .icon-free-data {
                    background: url("../../../assets/logo/home-sprite.png") -10px -10px;
                }
                .icon-secure {
                    background: url("../../../assets/logo/home-sprite.png") -144px -10px;
                }
                .icon-deals {
                    background: url("../../../assets/logo/home-sprite.png") -99px -10px;
                }
            }

            .list-item-text {
                font-size: 16px;
                color: #767676;
            }
        }
    }

    .row-line {
        display: flex;
        justify-content: space-between;

        .ebbly-app-img {
            height: 201px;
            width: 153px;
            background-size: auto 100%;
            background-position: center;
            background-repeat: no-repeat;
        }
    }

    .row-line-item {
        width: 561px;
        height: 235px;
        border-radius: 2px;
    }

    .download-bg {
        display: flex;
        box-sizing: border-box;
        padding: 34px 25px 0;
        background: linear-gradient(270.19deg, #00a9ba 0.49%, #48d7ce 99.87%);

        .download-content {
            flex: 1;
            min-width: 0;
            color: #fff;
            box-sizing: border-box;
            padding-left: 7px;
            padding-right: 30px;
            padding-bottom: 28px;

            .title {
                font-size: 24px;
                margin: 0;
                margin-bottom: 12px;
            }

            .text {
                font-size: 12px;
                line-height: 16px;
                color: #fff;
                opacity: 0.8;
                margin-bottom: 33px;
            }

            .store-img-link {
                display: inline-block;
                &:last-child {
                    margin-left: 30px;
                }
            }

            .store-img {
                height: 38px;
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/EbblyInfo.vue